import React, { PropTypes } from 'react'
import {
    Boolean,
    RadioInput,
    TextInput,
} from '../../ui'

import {
    computerTypeOptions,
    computerMakeOptions,
    getProperty,
} from '../../utils'

export default function ComputerSelectionFormOnly(props) {
    let computerTypeWidget = null
    let makeWidget = null
    let modelWidget = null
    let yearWidget = null
    let usb3Widget = null
    let thunderboltWidget = null
    let additionalDetailsWidget = null

    if (props.fields.includes('computer_type')) {
        computerTypeWidget = (
            <RadioInput
                error={ props.errors.computer_type }
                label="Computer Type"
                name={ `${ props.prefix }computer_type` }
                options={ computerTypeOptions() }
                updateValue={ props.updateValue }
                value={ getProperty(props.data, 'computer_type') }
            />
        )
    }
    if (props.fields.includes('make')) {
        makeWidget = (
            <RadioInput
                error={ props.errors.make }
                label="Make"
                name={ `${ props.prefix }make` }
                options={ computerMakeOptions() }
                updateValue={ props.updateValue }
                value={ getProperty(props.data, 'make') }
            />
        )
    }
    if (props.fields.includes('model')) {
        modelWidget = (
            <TextInput
                error={ props.errors.model }
                name={ `${ props.prefix }model` }
                placeholder="Model"
                updateValue={ props.updateValue }
                value={ getProperty(props.data, 'model') }
            />
        )
    }
    if (props.fields.includes('year')) {
        yearWidget = (
            <TextInput
                error={ props.errors.year }
                name={ `${ props.prefix }year` }
                placeholder="Year"
                type="number"
                updateValue={ props.updateValue }
                value={ getProperty(props.data, 'year') }
            />
        )
    }
    if (props.fields.includes('usb3')) {
        usb3Widget = (
            <Boolean
                error={ props.errors.usb3 }
                label="USB 3?"
                name={ `${ props.prefix }usb3` }
                updateValue={ props.updateValue }
                value={ getProperty(props.data, 'usb3') }
            />
        )
    }
    if (props.fields.includes('thunderbolt')) {
        thunderboltWidget = (
            <Boolean
                error={ props.errors.thunderbolt }
                label="Thunderbolt?"
                name={ `${ props.prefix }thunderbolt` }
                updateValue={ props.updateValue }
                value={ getProperty(props.data, 'thunderbolt') }
            />
        )
    }
    if (props.fields.includes('additional_details')) {
        additionalDetailsWidget = (
            <TextInput
                error={ props.errors.additional_details }
                label="Additional Details"
                name={ `${ props.prefix }additional_details` }
                rows="5"
                type="textarea"
                updateValue={ props.updateValue }
                value={ getProperty(props.data, 'additional_details') }
            />
        )
    }

    return (
        <div>
            { computerTypeWidget }
            { makeWidget }
            { modelWidget }
            { yearWidget }
            { usb3Widget }
            { thunderboltWidget }
            { additionalDetailsWidget }
        </div>
    )
}

ComputerSelectionFormOnly.propTypes = {
    data: PropTypes.object,
    errors: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
    fields: PropTypes.arrayOf(PropTypes.string).isRequired,
    prefix: PropTypes.string,
    updateValue: PropTypes.func.isRequired,
}
ComputerSelectionFormOnly.defaultProps = {
    prefix: '',
}



// WEBPACK FOOTER //
// ./app/components/gear/modals/computer_selection_form_only.js